import workspace from "../components/canvas/core/workspace";
//import {updateCurrentQuote} from "../../../../../misc/quotesFunctions";
import {
  getCurrentQuoteRoomCartItem,
  getRoomCartItemForCategoryName
} from "../../../misc/categorySwitchingFunctions";
import store from "../../../store";
import {setActiveQuoteIndex, setQuotes} from "../../../actions/roomsFunctions";
import {addToCart, changeCartFeature, removeFromCart, removeManyFromCart} from "../../../actions/actionFunctions";
import {prepareSQFTData} from "../components/canvas/core/workspace/workspaceDataMapper";
import {getFeatureGroup, getNavItems, onSQFTLoadImport, onSQFTLoadPrepareData} from "./sqftHelperUi";
import {ACTIVE_ROOM_TYPE} from "../../../reducers/sqft/sqftMenuReducer";
import {
  setSQFTActiveRoomId,
  setSQFTActiveRoomIndex,
  setSQFTActiveRoomType
} from "../../../actions/sqftMenuFunctions";
import {getRoomNameInQuote} from "../../popups/sqftFeaturesPopup/parseSqftData";
import {getQtCategoryName} from "../../visComponents/qtCategoryName";
import {getStringFeatureName} from "../../../misc/helpers";
import {MEASURE_UNITS} from "../constants";
import {WORKSPACE_CONTROLLERS_THAT_ADDS_FEATURES} from "../components/canvas/store/workspaceControllers";
import {setNewActiveQuote} from "../../../misc/quotesFunctions";
import {getActiveSQFTQuoteIndex} from "./sqftQuoteIndexHelper";

/**
 *
 */
export const getQtCatName = () => {
  const reduxState = store.getState();
  const {activeRoomType} = reduxState.sqftMenuState;
  const {qtActiveCategory} = reduxState.qtState;
  const {activeRoomId} = reduxState.sqftMenuState;
  const {activeQuoteIndex} = reduxState.quotesState;
  const fabricatorData = reduxState.fabricatorState;
  const intl = workspace.intl;

  let switcherTitle;
  let roomNavItem;

  switch (activeRoomType) {
    case ACTIVE_ROOM_TYPE.quote:
      switcherTitle = getRoomNameInQuote(activeQuoteIndex);
      break;
    case ACTIVE_ROOM_TYPE.category:
      switcherTitle = getQtCategoryName(qtActiveCategory, intl, fabricatorData)
      break;
    case ACTIVE_ROOM_TYPE.roomGroup:
      roomNavItem = getRoomGroupById(activeRoomId);
      if (!roomNavItem) {
        switcherTitle = ""
      } else {
        switcherTitle = getStringFeatureName(roomNavItem.part, intl.messages, intl.locale, fabricatorData);
      }
      break;
  }

  return switcherTitle;
}
/**
 * @param qtCatName string
 */
export const isQuoteByQTCatNameEqualToCurrentQuote = (qtCatName) => {
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  const activeQuoteIndex = state.quotesState.activeQuoteIndex;
  const quote = getQuoteByRoomName(qtCatName);
  let newQuoteIndex = quotes.indexOf(quote);
  newQuoteIndex = newQuoteIndex < 0 ? 0 : newQuoteIndex

  return activeQuoteIndex === newQuoteIndex
}
/**
 * @param qtCatName string
 */
export const loadQuoteByQtCatName = async (qtCatName) => {
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  const quote = getQuoteByRoomName(qtCatName);
  let quoteIndex = quotes.indexOf(quote);
  quoteIndex = quoteIndex < 0 ? 0 : quoteIndex

  store.dispatch(setActiveQuoteIndex(quoteIndex));
  await setNewActiveQuote(quoteIndex, quotes); // change wizardValues! switch from sqft issue
  //await setNewActiveQuote(quoteIndex, quotes);
  await loadActiveQuoteToSQFT();

  //todo fix error if quote is null
  store.dispatch(setSQFTActiveRoomId(qtCatName));
  store.dispatch(setSQFTActiveRoomIndex(null)); //todo if this is critical (set active room in qtCategory switcher)
  store.dispatch(setSQFTActiveRoomType(ACTIVE_ROOM_TYPE.quote));
}


/**
 * load quotes[activeQuoteIndex] to workspace
 */
export const getQuoteByRoomName = (roomName) => {
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  return quotes.find((quote, index) => {
    const quoteByQtCatName = quote.qtCatName === roomName.trim().toLowerCase();
    const roomNameInQuote = getRoomNameInQuote(index);
    const quoteByRoomName = roomNameInQuote.trim().toLowerCase() === roomName.trim().toLowerCase();

    return quoteByQtCatName || quoteByRoomName
  });
}

/**
 * load quotes[activeQuoteIndex] to workspace
 */
export const loadActiveQuoteToSQFT = async () => {
  let payload = onSQFTLoadPrepareData();
  onSQFTLoadImport(payload);
}

/**
 * Checking type of current room and creates new or updating existing quote
 * @param sqftCalcData {object}
 */
export const saveSQFTDataToQuote = async (sqftCalcData = null) => {
  const state = store.getState();
  const activeRoomType = state.sqftMenuState.activeRoomType;
  const qtActiveCategory = state.qtState.qtActiveCategory;
  const activeRoomId = state.sqftMenuState.activeRoomId;
  const cartItems = state.cartState.cartItems;
  const activeRoomIndex = state.sqftMenuState.activeRoomIndex;

  if (activeRoomType === ACTIVE_ROOM_TYPE.category) {
    await createQuoteIfNotExistOrUpdateCurrent(qtActiveCategory.trim().toLowerCase());
  } else if (activeRoomType === ACTIVE_ROOM_TYPE.roomGroup) {
    //const roomNavItem = getRoomGroupById(activeRoomId);
    //const roomNavItemName = roomNavItem.part.partName.trim().toLowerCase();
    await createQuoteIfNotExistOrUpdateCurrent(activeRoomId);
  } else {
    if (!sqftCalcData) {
      sqftCalcData = await prepareSQFTData();
      console.log("sqft prepared data", sqftCalcData);
    }
    updateQuoteWithSQFTData(sqftCalcData, getActiveSQFTQuoteIndex());
    const quoteRoomCartItem = getCurrentQuoteRoomCartItem(cartItems, activeRoomIndex);
    if (!quoteRoomCartItem) {
      const qtCatName = getQtCatName();
      if (qtCatName) {
        addRoomToCart(qtCatName);
      }
    }
  }
}

/**
 * Update specific quote with sqFtCalcData by given index
 */
export const updateQuoteWithSQFTData = (data, quoteIndex) => {
  const state = store.getState();
  const { quotes } = state.quotesState;

  const newQuotes = quotes.map((quote, qIndex) => {
    if (qIndex === quoteIndex) {
      return {
        ...quote,
        sqFtCalcData: { ...data }
      };
    }
    return quote;
  });

  store.dispatch(setQuotes(newQuotes));
};

/**
 * Update active quote with sqFtCalcData
 */
export const updateActiveQuoteWithSQFTData = (data) => {
  updateQuoteWithSQFTData(data, getActiveSQFTQuoteIndex());
};

export const getSQFTIdsFromCartItems = (cartItems) => {
  return cartItems.flatMap(cartItem => cartItem.sqftIds);
}

export const getSQFTIdsFromAllParentLists = (parentsLists) => {
  const SQFTIds = [];

  parentsLists.forEach(parentsList => {
    Object.keys(parentsList).forEach(parentKey => {
      if (!parentsList[parentKey]) {
        return;
      }

      if (parentsList[parentKey].features && parentsList[parentKey].features.length) {
        parentsList[parentKey].features.forEach(sqftFeature => {
          if (sqftFeature.sqftId) {
            SQFTIds.push(sqftFeature.sqftId);
          }
        });
      }

      if (parentsList[parentKey].featuresSubGroups) {
        parentsList[parentKey].featuresSubGroups.forEach(featureGroup => {
          if (featureGroup && featureGroup.features && featureGroup.features.length) {
            featureGroup.features.forEach(sqftFeature => {
              if (sqftFeature.sqftId) {
                SQFTIds.push(sqftFeature.sqftId);
              }
            });
          }
        });
      }
    });
  });

  return SQFTIds;
};

/**
 */
export const deleteCartItemsThatAreMissingInParentLists = (parentsLists, cartItems) => {
  const sqftIds = getSQFTIdsFromAllParentLists(parentsLists);
  const itemsToRemove = cartItems.filter(cItem => cItem.sqftId && !sqftIds.includes(cItem.sqftId));

  itemsToRemove.forEach(cItem => {
    store.dispatch(removeFromCart(cItem));
  });
};

/**
 * @param SQFTCalcData
 * @return {[]}
 */
export const getSQFTIdToFeatureIdsMap = (SQFTCalcData) => {
  const map = {};
  if (!SQFTCalcData) return map;

  // Countertops
  if (Array.isArray(SQFTCalcData.countertops)) {
    SQFTCalcData.countertops.forEach(ct => {
      if (!ct || !ct.id) return;

      const idStr = ct.id.toString();
      if (!map[idStr]) map[idStr] = [];

      // From features array
      if (Array.isArray(ct.features)) {
        ct.features.forEach(f => {
          if (f && f.featureId && map[idStr].indexOf(f.featureId) === -1) {
            map[idStr].push(f.featureId);
          }
        });
      }

      // Also fallback to top-level featureId
      if (ct.featureId && map[idStr].indexOf(ct.featureId) === -1) {
        map[idStr].push(ct.featureId);
      }
    });
  }

  // Controllers (hinge, handles)
  if (SQFTCalcData.controllers) {
    WORKSPACE_CONTROLLERS_THAT_ADDS_FEATURES.forEach(type => {
      const items = SQFTCalcData.controllers[type];
      if (Array.isArray(items)) {
        items.forEach(model => {
          if (model && model.id && model.featureId) {
            const idStr = model.id.toString();
            if (!map[idStr]) map[idStr] = [];
            if (map[idStr].indexOf(model.featureId) === -1) {
              map[idStr].push(model.featureId);
            }
          }
        });
      }
    });
  }

  return map;
};

/**
 */
export const deleteSQFTCartItems = () => {
  const state = store.getState();
  const ids = state.cartState.cartItems.filter(ci => ci.sqftId || ci.sqftIds).map(ci => ci.id);
  store.dispatch(removeManyFromCart(ids));
}

export const deleteCartItemsThatAreMissingInSQFTCalcData = () => {
  const state = store.getState();
  const cartItems = state.cartState.cartItems;
  const fabricatorSettings = state.fabricatorState.settings;
  const quotes = state.quotesState.quotes;

  quotes.forEach((quote, quoteIndex) => {
    if (!quote.sqFtCalcData) return;

    const idToFeatureIds = getSQFTIdToFeatureIdsMap(quote.sqFtCalcData);

    // Track which featureIds have been used for each sqftId + quantityGroup ('doors' 'drawers')
    const sqftIdToUsedFeatureIdsBySubPart = {};

    cartItems
      .filter(cItem => cItem.currentQuote === quoteIndex)
      .filter(cItem => !cItem.bundleParentId)
      .forEach(cItem => {
        if (!cItem.sqftQuantities) return;

        const updatedQuantities = { ...cItem.sqftQuantities };
        const cartFeatureId = cItem.cartFeature?.dbFeature?.id;
        const quantityGroup = cItem.quantityGroup || "__none__";

        Object.keys(updatedQuantities).forEach(sqftId => {
          const validFeatureIds = idToFeatureIds[sqftId];

          if (!validFeatureIds || !cartFeatureId) {
            delete updatedQuantities[sqftId];
            return;
          }

          // Init map layer for this sqftId and quantityGroup
          if (!sqftIdToUsedFeatureIdsBySubPart[sqftId]) {
            sqftIdToUsedFeatureIdsBySubPart[sqftId] = {};
          }
          if (!sqftIdToUsedFeatureIdsBySubPart[sqftId][quantityGroup]) {
            sqftIdToUsedFeatureIdsBySubPart[sqftId][quantityGroup] = [];
          }

          const featureAlreadyUsed =
            sqftIdToUsedFeatureIdsBySubPart[sqftId][quantityGroup].includes(cartFeatureId);

          const featureIsValid = validFeatureIds.includes(cartFeatureId);

          if (!featureIsValid || featureAlreadyUsed) {
            delete updatedQuantities[sqftId];
            return;
          }

          // Register this featureId as used for this sqftId + quantityGroup
          sqftIdToUsedFeatureIdsBySubPart[sqftId][quantityGroup].push(cartFeatureId);
        });

        // Preserve manual and change-order quantities when no linked SQFT items were removed. QCDES-8776
        const hasRemovedSqftQuantity = Object.keys(updatedQuantities).length !== Object.keys(cItem.sqftQuantities).length;
        if (!hasRemovedSqftQuantity) {
          return;
        }

        let newQuantity = Object.values(updatedQuantities).reduce((sum, qty) => sum + qty, 0);
        newQuantity = fabricatorSettings.measureUnit === MEASURE_UNITS.Metric
          ? Math.ceil10(newQuantity, -2)
          : Math.ceil(newQuantity);

        if (Object.keys(updatedQuantities).length > 0) {
          store.dispatch(changeCartFeature({
            ...cItem,
            sqftQuantities: updatedQuantities,
            quantity: newQuantity,
          }));
        } else {
          store.dispatch(removeFromCart(cItem));
        }
      });
  });
};

/**
 * @param qtCatName: string
 */
export const createQuoteIfNotExistOrUpdateCurrent = async (qtCatName) => {
  const currentQtCategoryInQuotes = getQuoteForCurrentQtCatName(qtCatName);
  const sqftCalcData = await prepareSQFTData();
  if (!currentQtCategoryInQuotes) {
    await createQuoteFromSqftCalcData(sqftCalcData, qtCatName)
  } else {
    updateActiveQuoteWithSQFTData(sqftCalcData);
  }
}

/**
 * @param sqftCalcData {object}
 * @param qtCatName {string}
 */
export const createQuoteFromSqftCalcData = async (sqftCalcData, qtCatName) => {
  if (!workspace.isEmpty() || isManualCalculateNotEmpty(sqftCalcData)) {
    await createNewQuoteFromCategory(sqftCalcData, qtCatName);
  }
}

/**
 * @param qtCatName string
 */
export const getQuoteForCurrentQtCatName = (qtCatName) => {
  const {quotes} = store.getState().quotesState;
  return quotes.find(quote =>
    quote.qtCatName === qtCatName
    && quote.isVisibleInSQFT === false)
}

/**
 * @param sqftCalcData {object}
 * @param qtActiveCategory {string}
 */
export const createNewQuoteFromCategory = async(sqftCalcData, qtActiveCategory) => {
  if (!workspace.isEmpty() || isManualCalculateNotEmpty(sqftCalcData)) {
    const quotes = await addNewQuote(sqftCalcData, qtActiveCategory);
    store.dispatch(setActiveQuoteIndex(quotes.length - 1));
    addRoomToCart(qtActiveCategory);
  }
}

export const isManualCalculateNotEmpty = (sqftCalcData) => {
  if (sqftCalcData.manualCalculate) {
    return sqftCalcData.countertops.length > 0
      || sqftCalcData.backsplashes.length > 0
      || sqftCalcData.edges.length > 0
  }

  return false
}
/**
 * @param sqftCalcData {object}
 * @param qtActiveCategory {string}
 */
const addNewQuote = async (sqftCalcData, qtActiveCategory) => {
  //const currentQuote = await updateCurrentQuote();
  const {quotes} = store.getState().quotesState;
  const newQuotes = [...quotes, {
    quoteId: null,
    isCreatedInSQFT: true,
    isVisibleInSQFT: false,
    qtCatName: qtActiveCategory.trim().toLowerCase(),
    sqFtCalcData: sqftCalcData
  }];
  store.dispatch(setQuotes(newQuotes));

  return newQuotes
};

/**
 * @param qtCatName {string}
 */
export const addRoomToCart = (qtCatName) => {
  const roomCartItem = getRoomCartItemForCategoryName(qtCatName)
  if (roomCartItem) {
    store.dispatch(addToCart([roomCartItem]))
    return roomCartItem
  }
}

/**
 * update navItemBy roomIndex
 * @param roomName {string}
 */
export const getRoomGroupById = (roomName) => {
  const roomsFeatureGroup = getFeatureGroup('room');
  const roomsNavItems = getNavItems(roomsFeatureGroup, "", {}, false, true);

  return roomsNavItems.find(navItem => {
    return navItem.part.getFeatureName().toLowerCase() === roomName.toLowerCase()
  });
}
